import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ExtensionProvider = withAsync({
	loader: lazyForPaint(
		() => import(/* webpackChunkName: "forge-extension-provider" */ './extension-provider'),
	),
	LoadingSkeleton: () => null,
});
